import { render, staticRenderFns } from "./WorkerCreation.vue?vue&type=template&id=66089508&scoped=true"
import script from "./WorkerCreation.vue?vue&type=script&lang=ts"
export * from "./WorkerCreation.vue?vue&type=script&lang=ts"
import style0 from "./WorkerCreation.vue?vue&type=style&index=0&id=66089508&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66089508",
  null
  
)

export default component.exports